module.exports = __webpack_public_path__ + "static/media/step4.8d778b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/tbank/step4.jpg
// module id = 714
// module chunks = 0